const showPopupList = [
  'OptimhomeAgent',
  'CapifranceAgent',
  'LaforetAgent',
  'LotsAgent',
  'EmailMandant',
  'LaforetEmailPhone',
  'LotsADB',
  'ToutvabiensAgent',
  'BricomarcheEmail',
  'MousquetairesRDV',
];
export default showPopupList;
